<template>
  <div class="submit_pay">
    <!-- <van-nav-bar title="支付订单"
                 left-arrow
                 @click-left="onClickLeft" /> -->
    <div class="paySuc-top">
      <p>
        <i class="van-icon van-icon-passed"></i>
        <span class='pay-suc'>订单创建成功</span>
        <span class='pay-style common-g'>请在24小时内完成支付</span>
        <span class='pay-mon'>支付金额<span>￥{{this.paysum}}</span></span>
      </p>
    </div>
    <div class='pay-list'>
      <div class='pay-list-title'>支付方式</div>
      <div class='pay-list-con clearfix'>
        <ul>
          <li v-for="item in paylist "
              @click='payMoney(item)'
              :key='item'>
            <b></b>
            <span>{{item}}</span>
            <b></b>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { Radio } from 'vant'

import { fdatasync, constants } from 'fs';
//import {eventBus} from '../../assets/js/eventBus'

export default {
  name: 'submit_pay',
  store,
  data () {
    return {
      paysum: '',
      payway: "",
      paylist: ['支付宝', '微信', '银联支付'],
      payResult: ['支付宝'],
      actions: [
        { name: '支付宝' },
        { name: '微信' },
        { name: '银联支付' }
      ],
      list: [],//当前订单信息
      detailChosenList: this.$store.state.detailChosenList
    }
  },
  created () {
    //创建
    ////debugger
    this.paysum = this.$route.params.money;
  },
  mounted () {
    //原生调返回
    window['backToPay'] = () => {
      this.onClickLeft();
    }
  },
  methods: {
    onClickLeft () {
      debugger
      this.$router.push('/pay');
    },
    payMoney (item) {
      //  //debugger
      console.log(this.$store.state.allGood);
      this.list = this.$store.state.allGood;//allGood数组

      for (let i = 0; i < this.list.length; i++) {
        //赋值给每一个商品
        //直接修改state，可以但不提倡
        this.list[i].payway = item;
        this.list[i].payMoney = this.paysum;
        this.list[i].payTime = this.formDate();
        this.list[i].orderNo = parseInt((Math.random()) * 10000000);
      }
      this.$store.state.allGood = this.list;

      console.log(this.$store.state.allGood);
      //获取到index，
      //模拟支付过程
      Dialog.confirm({
        title: '确认支付',
        message: '是否支付¥' + this.paysum
      })
        .then(() => {
          Toast.loading({
            mask: true,
            message: '支付中...'
          });
          let money = this.paysum;
          setTimeout(() => {
            //钩子函数解决作用域问题，原理理解
            this.$router.push({ path: `/paysuc/${item}/${money}` });
            //this.$router.push({ name: "submit_pay" });
          }, 3000)
        })
        .catch(() => {
          // on cancel
        });
    }
  }
}
</script>

<style lang="less" scope>
.submit_pay {
  .van-radio {
    padding: 20px;

    .van-radio__label {
      font-size: 0.3rem;
    }
  }
  .paySuc-top {
    padding: 0.98rem 5% 0;
    background: #fff;
    color: #333;
    margin-bottom: 0.66rem;
    p {
      display: flex;
      flex-direction: column;
      align-items: center;
      & > i {
        width: 2.28rem !important;
        height: 2.28rem !important;
        background: url("../../../static/image/goods/splitPic/payOrder/ios/form.png")
          no-repeat center center;
        margin-bottom: 0.64rem;
      }

      span {
        display: inline-block;
      }
    }
  }

  .btn {
    text-align: center;
    margin-bottom: 0.74rem;
  }

  .van-icon .van-icon-passed {
    width: 2.28rem !important;
    height: 2.28rem !important;
    background: url("../../../static/image/goods/splitPic/paySuccess/ios/successful.png")
      no-repeat center center;
  }
  .van-icon-passed:before {
    content: "";
  }
  .van-nav-bar__title {
    border-bottom: 1px solid #e5e5e5;
  }
  .pay-suc {
    font-size: 0.36rem;
    font-weight: bold;
    margin-bottom: 0.32rem;
  }
  .pay-style,
  .pay-mon {
    font-size: 0.24rem;
    color: #000;
    margin-bottom: 0.2rem;

    & > span {
      margin-left: 0.1rem;
      font-size: 0.28rem;
      color: rgb(255, 144, 0);
    }
  }

  .van-button--normal {
    width: 2.6rem;
    font-size: 14px;
    height: 0.88rem;
    border: 1px solid rgb(255, 144, 0);
    border-radius: 0.2rem;

    span {
      color: rgb(255, 144, 0);
    }
  }

  .common-g {
    color: rgb(153, 153, 153);
  }

  .pay-list {
    width: 100%;
    .pay-list-title {
      padding: 0 0.32rem;

      color: rgb(153, 153, 153);
      font-size: 0.22rem;
      margin-bottom: 0.16rem;
    }
    .pay-list-con {
      padding: 0 0.32rem;

      ul {
        & > li {
          line-height: 0.98rem;
          border-bottom: 1px solid #e5e5e5;
          & > input {
            margin-left: 0.32rem;
            width: 0.38rem;
            height: 0.38rem;
          }
          & > b:nth-child(1) {
            display: inline-block;
            width: 0.5rem;
            height: 0.5rem;
            margin-left: -0.1rem;
          }
          & > span {
            color: #000;
            font-size: 0.3rem;
            display: inline-block;
            height: 0.98rem;
            vertical-align: 5px;
          }
          & > b:nth-child(2) {
            display: inline-block;
            width: 0.28rem;
            height: 0.28rem;
            background-color: #f09;
          }

          &:nth-child(1) {
            & > b:nth-child(1) {
              background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay1.png")
                no-repeat center bottom;
            }
          }
          &:nth-child(2) {
            & > b:nth-child(1) {
              background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay2.png")
                no-repeat center center;
            }
          }
          &:nth-child(3) {
            & > b:nth-child(1) {
              background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay3.png")
                no-repeat center center;
            }
          }
        }
      }
    }
  }
}
.apply {
  background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay1.png")
    no-repeat center center;
}
.wechat {
  background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay2.png")
    no-repeat center center;
}
.cartpay {
  background: url("../../../static/image/goods/splitPic/payOrder/ios/Pay3.png")
    no-repeat center center;
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/submit_pay.vue